export const colors = {
  blue: '#33CCFF',
  cyan: '#103440',
  green: '#29CC44',
  lightBlue: '#F2FCFF',
  orange: '#FF7733',
}
export const lineHeight = 1.44
